import snukReducer from './snukReducer';

const machines = (state, action) => snukReducer(state, action, 'machines');

export default machines;



// WEBPACK FOOTER //
// ./src/reducers/machines.js